var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('password-form',{attrs:{"submit-label":_vm.$t('Update'),"working-submit-label":_vm.$t('Updating...'),"status":_vm.status,"process":_vm.onProcessPassword,"horizontal":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }